export default {
  es: {
    ACCOUNT_ORDERS: '/es/account/orders',
    ACCOUNT_PERSONAL: '/es/account/personal',
    ACCOUNT_PERSONAL_DATA_EDIT: '/es/account/personal/data/edit',
    ACCOUNT_PRIVACY: '/es/account/privacy',
    ACCOUNT_PERSONAL_ADDRESS_EDIT: '/es/account/personal/addresses/edit/:addressID',
    ACCOUNT_PERSONAL_ADDRESS_ADD: '/es/account/personal/addresses/add',
    ACCOUNT_ORDER_DETAIL: '/es/account/orders/:orderID',
    ACCOUNT_VERIFICATION: '/es/account/verify/:token',
    AUTH: '/es/entrar',
    CATALOG: '/es/catalogo/:type',
    CHECKOUT_DELIVERY: '/es/checkout/delivery',
    CHECKOUT_PAYMENT: '/es/checkout/payment',
    CHECKOUT_REVIEW: '/es/checkout/review',
    CHECKOUT_REVIEW_RECOMMENDATIONS: '/ca/checkout/review/recommendations',
    CHECKOUT_THANKS: '/es/checkout/thanks',
    MERCHANT_PRIVACY_POLICY: 'merchant-privacy-policy',
    HOME: '/es',
    PRIVACY_POLICY: 'privacy-policy',
    PRODUCT: '/es/producto/:slug/:productID',
    RECOVERY: '/es/recovery',
    RESET_PASSWORD: '/es/reset-password/:token',
    STATIC_PAGE: '/es/static/:page',
    TERMS_AND_CONDITIONS: 'terms-and-conditions',
    LEGAL_AGE_CHECK: 'legal-age'
  },
  ca: {
    ACCOUNT_ORDERS: '/ca/account/orders',
    ACCOUNT_PERSONAL: '/ca/account/personal',
    ACCOUNT_PERSONAL_DATA_EDIT: '/ca/account/personal/data/edit',
    ACCOUNT_PRIVACY: '/ca/account/privacy',
    ACCOUNT_PERSONAL_ADDRESS_EDIT: '/ca/account/personal/addresses/edit/:addressID',
    ACCOUNT_PERSONAL_ADDRESS_ADD: '/ca/account/personal/addresses/add',
    ACCOUNT_ORDER_DETAIL: '/ca/account/orders/:orderID',
    ACCOUNT_VERIFICATION: '/ca/account/verify/:token',
    AUTH: '/ca/entrar',
    CATALOG: '/ca/cataleg/:type',
    CHECKOUT_DELIVERY: '/ca/checkout/delivery',
    CHECKOUT_PAYMENT: '/ca/checkout/payment',
    CHECKOUT_REVIEW: '/ca/checkout/review',
    CHECKOUT_REVIEW_RECOMMENDATIONS: '/ca/checkout/review/recommendations',
    CHECKOUT_THANKS: '/ca/checkout/thanks',
    MERCHANT_PRIVACY_POLICY: 'merchant-privacy-policy',
    HOME: '/ca',
    PRIVACY_POLICY: 'privacy-policy',
    PRODUCT: '/ca/producte/:slug/:productID',
    RECOVERY: '/ca/recovery',
    RESET_PASSWORD: '/ca/reset-password/:token',
    STATIC_PAGE: '/ca/static/:page',
    TERMS_AND_CONDITIONS: 'terms-and-conditions',
    LEGAL_AGE_CHECK: 'legal-age'
  }
}
